import React, { useContext } from 'react'
import '../styles/error.css'
import AppContext from '../context/Context'

export default function PageError () {
  const { setError } = useContext(AppContext)
  return (
    <div className='error-container'>
      <div>
        <p>Ocorreu um erro</p>
        <button
          onClick={() => setError(false)}
        >
          X
        </button>
      </div>
    </div>
  )
}
